import {
  Crown,
  Dice5,
  Flame,
  Gem,
  Medal,
  Rocket,
  Target,
  Trophy,
  type LucideIcon,
} from '@lucide/vue';

/**
 * 平台预置头像图集：玩家从中直接选择，不上传文件。
 * `id` 即入库 `avatar_url` 的值，后端白名单需与此清单保持一致。
 * 视觉走主题令牌驱动的图标 + 渐变，不依赖二进制图片素材。
 */
export interface PresetAvatar {
  gradient: string;
  icon: LucideIcon;
  id: string;
  label: string;
}

export const presetAvatars: PresetAvatar[] = [
  {
    gradient: 'linear-gradient(140deg, oklch(0.74 0.21 42), oklch(0.62 0.23 30))',
    icon: Trophy,
    id: 'trophy',
    label: 'Troféu',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.72 0.2 55), oklch(0.6 0.22 32))',
    icon: Flame,
    id: 'flame',
    label: 'Chama',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.82 0.17 90), oklch(0.7 0.19 70))',
    icon: Crown,
    id: 'crown',
    label: 'Coroa',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.7 0.18 260), oklch(0.58 0.2 290))',
    icon: Rocket,
    id: 'rocket',
    label: 'Foguete',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.74 0.16 200), oklch(0.6 0.18 230))',
    icon: Gem,
    id: 'gem',
    label: 'Joia',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.73 0.18 150), oklch(0.6 0.18 165))',
    icon: Dice5,
    id: 'dice',
    label: 'Dados',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.78 0.16 70), oklch(0.66 0.2 45))',
    icon: Medal,
    id: 'medal',
    label: 'Medalha',
  },
  {
    gradient: 'linear-gradient(140deg, oklch(0.68 0.21 12), oklch(0.56 0.22 18))',
    icon: Target,
    id: 'target',
    label: 'Alvo',
  },
];

export const presetAvatarIds = presetAvatars.map((avatar) => avatar.id);

export const defaultAvatarId = presetAvatars[0]!.id;

export const findPresetAvatar = (id: string | null | undefined): PresetAvatar =>
  presetAvatars.find((avatar) => avatar.id === id) ?? presetAvatars[0]!;

export const isPresetAvatarId = (id: string | null | undefined): boolean =>
  Boolean(id) && presetAvatarIds.includes(id as string);
